import connectMeLogo from '../assets/connectme-logo.png';
import hiZipLogo from '../assets/hizip-logo.png';
import vithenicsLogo from '../assets/vithenics-logo.png';

const Solutions = () => {
  const solutions = [
    { icon: <img src={connectMeLogo} alt='ConnectMe' className='w-full h-full object-contain' />, title: 'ConnectMe', description: 'Мессенджер без лишнего: быстрые сообщения и звонки, которые не тормозят на слабом интернете.', link: 'https://connect-me.hisphere.net', cta: 'Открыть ConnectMe' },
    { icon: <img src={hiZipLogo} alt='HiZip' className='w-full h-full object-contain' />, title: 'HiZip', description: 'Упаковывает файлы — распаковывает нервы. Работает мгновенно, выглядит как будущее.', link: '/HiZip Setup 1.0.1.exe', cta: 'Скачать HiZip' },
    { icon: <img src={vithenicsLogo} alt='Vithenics' className='w-full h-full object-contain' />, title: 'Vithenics', description: 'Приложение для тренировок по калистенике: программы, техника и прогресс в одном месте.', link: 'https://vithenics.corruptor.pro', cta: 'Попробовать Vithenics' }
  ];

  return (
    <section id='solutions' className='py-32 relative overflow-hidden'>
      <div className='before:content-[""] before:absolute before:-top-80 before:-right-80 before:w-[800px] before:h-[800px] before:bg-gradient-radial before:from-cyan-400/10 before:to-transparent before:z-0 before:animate-pulse'></div>
      <div className='container mx-auto px-8 max-w-7xl relative z-10'>
        <div className='text-center mb-20 animate'>
          <h2 className='section-title'>
            Наши решения
          </h2>
          <p className='text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto'>
            Три независимых продукта под одной командой — каждый закрывает свою задачу.
          </p>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          {solutions.map((feature, index) => (
            <div
              key={index}
              className='feature-card glass-card rounded-2xl p-6 relative overflow-hidden animate'
            >
              <div className='w-28 h-28 flex items-center justify-center mb-4 transition-all duration-300 hover:rotate-12 hover:scale-110'>
                {feature.icon}
              </div>
              <h3 className='text-xl font-montserrat font-bold mb-2 text-gray-900 dark:text-white relative
                after:content-[""] after:absolute after:bottom-[-5px] after:left-0 after:w-0 after:h-0.5 after:bg-cyan-400 after:transition-all after:duration-300 group-hover:after:w-full'>
                {feature.title}
              </h3>
              <p className='text-gray-600 dark:text-gray-400 mb-4'>{feature.description}</p>
              {!!feature.link ? (
                <a
                  href={feature.link}
                  target='_blank'
                  className='inline-flex items-center text-sky-500 dark:text-cyan-300 font-semibold hover:text-cyan-400 transition-all duration-200 group'
                >
                  {feature.cta || 'Перейти'}
                </a>
              ) : (
                <button
                  disabled
                  className='inline-flex items-center text-gray-400 font-semibold cursor-not-allowed transition-all duration-200 group'
                >
                  Скоро в разработке
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
